import React from 'react'
import About from '../component/About';
import Management from '../component/Management';
import Orgcharts from '../component/Orgcharts';
import Warehousechart from '../component/Warehousechart';
import ManagementOrgChart from '../component/ManagementOrgChart';
import WarehouseOrgChart from '../component/WarehouseOrgChart';

function AboutPage() {
  return (
    <div>
      <About />
      <Management />
      {/* <Orgcharts />
      <Warehousechart /> */}
      <ManagementOrgChart />
      <WarehouseOrgChart />
    </div>
  )
}

export default AboutPage